import { render, staticRenderFns } from "./FormulirDetail.vue?vue&type=template&id=67fbf090&scoped=true"
import script from "./FormulirDetail.vue?vue&type=script&lang=js"
export * from "./FormulirDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fbf090",
  null
  
)

export default component.exports